import {Routes} from "@angular/router";
import {AuthenticationGuard, AuthorizationGuard} from "@softline/auth";
import {kopfVorhandenGuard} from './guards/kopf-vorhanden.guard';

export const absatzplanRoutes: Routes = [
  {
    path: 'absatzplan',
    loadComponent: () => import('./components/absatzplan.component'),
    children: [
      {
        path: 'abfrage',
        loadComponent: () => import('./pages/query/query.component'),
      },
      {
        path: 'einlesen',
        loadComponent: () => import('./pages/einlesen/einlesen.component'),
      },
      {
        path: 'ergebnis',
        loadComponent: () => import('./pages/result/result.component'),
      },
      {
        path: ':id',
        loadComponent: () => import('./pages/result/result.component'),
      },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: '/absatzplan/abfrage',
      },
    ],
    canActivate: [
      AuthenticationGuard,
      AuthorizationGuard
    ],
  }
]
